import NavDiv from "./NavDiv";
import { useState } from "react";

const MainDiv = (props) => {
  let [changeNavHeight, setNavHeigth] = useState(0);
  let [didShowNav, setDidShowNav] = useState(true);
  let interval;
  let showNav = () => {
    interval = setInterval(() => {
      if (changeNavHeight >= 101) {
        clearInterval(interval);
      } else {
        setNavHeigth(changeNavHeight++);
      }
    }, 5);

    setDidShowNav(!didShowNav);
  };
  let hideNav = () => {
    interval = setInterval(() => {
      if (changeNavHeight <= -1) {
        clearInterval(interval);
      } else {
        setNavHeigth(changeNavHeight--);
      }
    }, 5);
    setDidShowNav(!didShowNav);
  };
  return (
    <div className="mainDiv">
      <NavDiv navHeight={changeNavHeight + "vh"} />
      <i
        className={
          didShowNav ? "menu_icon fas fa-bars" : "menu_icon fas fa-times"
        }
        onClick={didShowNav ? showNav : hideNav}
      ></i>
      <h1>ABOVE</h1>
      <i className="fas fa-caret-down"></i>
      {/* <Cubes posLeft='10%' posTop='90%' /> */}
    </div>
  );
};

export default MainDiv;
